<script setup>
import PageGuide from '@/components/panel/PageGuide.vue'
import PanelHelp from '@/components/panel/Help.vue'

import BackButton from "@/components/app/BackButton/index.vue"
import { BUSINESS_NAVIGATION } from "@/constants/businessNavigation"

const route = useRoute()
const authStore = useAuthStore()
const routeCopy = [
  ["/appointment/create", "ایجاد نوبت", "زمان‌های جدید قابل رزرو را تنظیم کن"],
  ["/appointment/edit", "ویرایش نوبت‌ها", "نوبت‌های تنظیم‌شده را مشاهده و اصلاح کن"],
  ["/appointment/state", "وضعیت نوبت", "دریافت خدمت و امتیاز مشتری را مدیریت کن"],
  ["/appointment/cancel", "لغو و غیرفعال‌سازی", "ظرفیت‌های رزرو را کنترل کن"],
  ["/appointment/search", "جستجوی نوبت", "رزروها را سریع پیدا کن"],
  ["/information/data", "اطلاعات مجموعه", "مشخصات و نشانی کسب‌وکار را ویرایش کن"],
  ["/information/media", "رسانه‌های مجموعه", "لوگو و تصاویر مجموعه را مدیریت کن"],
]
const currentNavigation = computed(() => BUSINESS_NAVIGATION.find(item => item.exact ? route.path === item.to : route.path.startsWith(item.to)))
const currentChild = computed(() => routeCopy.find(([suffix]) => route.path.endsWith(suffix)))
const title = computed(() => String(route.meta?.businessTitle || currentChild.value?.[1] || currentNavigation.value?.title || "مدیریت کسب‌وکار"))
const subtitle = computed(() => String(route.meta?.businessSubtitle || currentChild.value?.[2] || currentNavigation.value?.description || "همه‌چیز برای مدیریت بهتر مجموعه"))
const displayPhone = computed(() => authStore.ownerPhoneNumber || "مدیر مجموعه")
</script>

<template>
  <header class="business-header">
    <div class="business-header__intro">
      <BackButton @click="$router.back()" />
      <div><h1>{{ title }}<PageGuide :title="title" /><PanelHelp fallback-tag="p">{{ subtitle }}</PanelHelp></h1></div>
    </div>
    <div class="business-header__tools">
      <BusinessContextSwitcher />
      <div class="business-header__profile"><VIcon icon="tabler-user" size="18" /><span>{{ displayPhone }}</span></div>
    </div>
  </header>
</template>

<style scoped lang="scss">
.business-header { position: sticky; z-index: 20; top: 0; display: flex; min-height: 78px; align-items: center; justify-content: space-between; gap: 18px; padding: 12px 24px; border-bottom: 1px solid rgba(40,35,64,.07); background: rgba(250,249,252,.91); backdrop-filter: blur(18px); }
.business-header__intro,.business-header__tools,.business-header__profile { display: flex; align-items: center; }
.business-header__intro { gap: 10px; }

.business-header h1 { margin: 0; color: #2f2942; font-size: 17px; }
.business-header p { margin: 3px 0 0; color: #9993a5; font-size: 9px; }
.business-header__tools { gap: 9px; }
.business-header__profile { gap: 7px; min-height: 48px; padding: 0 12px; border: 1px solid #ebe8f1; border-radius: 14px; background: #fff; color: #6f697d; font-size: 10px; }
@media (max-width: 759px) { .business-header { position: relative; display: grid; padding: 13px 14px; } .business-header__tools { width: 100%; } .business-header__profile { display: none; } .business-header h1 { font-size: 15px; } }
</style>
